export const STREAM_EVENTS_LOAD = 'STREAM_EVENTS_LOAD';

export const STREAM_EVENTS_SAVE = 'STREAM_EVENTS_SAVE';

export const STREAM_EVENTS_UPDATE = 'STREAM_EVENTS_UPDATE';


export const STREAM_EVENTS_ERROR = 'STREAM_EVENTS_ERROR'